import React from 'react'
import Head from 'next/head'
import { storyblokInstance } from '../services/storyblok-service'

export const Bridge: React.FC = ({ children }) => (
  <div>
    <Head>{storyblokInstance.bridge()}</Head>
    {children}
  </div>
)
